import { Flex, type ListRef, Spinner } from '@banhala/ui-kit';
import { AtomicRenderer } from 'shared/src/component';
import { useGetTodayScreensInfiniteQuery } from './queries/useGetTodayScreensInfiniteQuery';
import { StyleSheet, View } from 'react-native';
import { useContext, useRef } from 'react';
import type { IScreensComponent } from 'shared/src/api';
import { useScrollToFilterList } from './hooks/useScrollToFilterList';
import { HomeScrollContext } from '../../context/HomeScrollContext';
import { useIsTabFocused } from '../../hooks/useIsTabFocused';

export type AtomicRendererRefCurrent = ListRef<IScreensComponent>;

export const TodayAtomic: React.FC<{
  screenName: string;
  nextToken?: string;
}> = props => {
  const atomicRendererRef = useRef<AtomicRendererRefCurrent>(null);
  const homeScroll = useContext(HomeScrollContext);
  const { data, fetchNextPage, isFetching, refetch } =
    useGetTodayScreensInfiniteQuery(props.screenName, props.nextToken);
  const { filterListIndex, scrollToFilterList } = useScrollToFilterList({
    atomicRendererRef,
    components: data?.components,
  });
  const focused = useIsTabFocused(props.screenName);

  if (!data) {
    return (
      <Flex.Center flex={1}>
        <Spinner size={20} />
      </Flex.Center>
    );
  }

  return (
    <Flex flex={1}>
      {isFetching && (
        <View style={styles.spinnerContainer}>
          <Spinner size={20} />
        </View>
      )}
      <AtomicRenderer
        refetch={refetch}
        data={data ?? []}
        fetchNextPage={fetchNextPage}
        listRef={atomicRendererRef}
        filterListIndex={filterListIndex}
        scrollToFilterList={scrollToFilterList}
        isFetching={isFetching}
        onScrollY={homeScroll?.onScrollY}
        scrollYSharedValue={homeScroll?.scrollY}
        logDisabled={!focused}
      />
    </Flex>
  );
};
const styles = StyleSheet.create({
  spinnerContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: -10 }, { translateY: -10 }],
    zIndex: 1000,
  },
});
